import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Slider.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

export default function Slider() {
  return (
    <>
    <h1 className="title-slider">Review's</h1>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide><img src="./images/review1.jpg" alt=" " /></SwiperSlide>
        <SwiperSlide><img src="./images/review2.jpg" alt=" " /></SwiperSlide>
        <SwiperSlide><img src="./images/review3.jpg" alt=" " /></SwiperSlide>
        <SwiperSlide><img src="./images/review4.jpg" alt=" " /></SwiperSlide>
        <SwiperSlide><img src="./images/review5.jpg" alt=" " /></SwiperSlide>
        <SwiperSlide><img src="./images/review6.jpg" alt=" " /></SwiperSlide>
      </Swiper>
    </>
  );
}
